import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auctions-three-section',
  templateUrl: './auctions-three-section.component.html',
  styleUrls: ['./auctions-three-section.component.scss']
})
export class AuctionsThreeSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
